<template>
    <div class="dorm-wrapper">

<!--     <div class="vld-parent mycenter">
        <loading :active.sync="isLoading"
        :is-full-page="fullPage"></loading>
    </div>  -->

      <div v-if="isShowFormMobile" class="fixed_mobile_overlay"></div>
      <div v-if="showMobileBottom" class="fixed-mobile" style="display: none">
          <div class="fixed-mobile__top">
            <form id="my-form" ref="myMessageForm" v-if="isShowFormMobile" @submit.prevent="submitForm">

              <div class="dorm-form-tab">
                    <div icon="icon-mail" class="dorm-form-tab__item mycolor mycursor1">
                        <svg viewBox="0 0 20 20" class="icon" style="font-size: 30px; color: rgb(235, 96, 129);">
                            <use xlink:href="/icon/icons.svg#icon-fiyat-sor"></use>
                        </svg>
                        <div class="dorm-form-tab__title">LEARN RENT PRICE</div>
                    </div>
                </div>
            <div class="clear" v-on:click="closeSuccessMessage" ><span class="close" ref="close" >&times;</span></div>
             <v-input ref="myInput" placeholder="Fullname" v-model="messageForm.name" v-on:keyup.native="saveForm"/>
            <label for="password" v-if="emptyName" class="myValidationText">Can not be leave empty!</label>
             <VueSelectTempUniversity :options="universities" placeholder="Select Genre" @onselect="selectUniversity"/>
             <label for="password" v-if="emptyUniversity" class="myValidationText">Can not be leave empty!</label>
            <VueSelectTempFaculty :options="faculties" placeholder="Select Studio" @onselect="selectFaculty"/>
            <label for="password" v-if="emptyFaculty" class="myValidationText">Can not be leave empty!</label>
             <VueInputRestricted  placeholder="Telefon No" v-on:keyup.native="saveForm" v-model="messageForm.phone"/>
             <label for="phone" v-if="emptyPhone" class="myValidationText">Can not be leave empty!</label>
             <label for="phone" v-if="falsePhone" class="myValidationText">Phone number must start with 0!</label>
             <label for="phone" v-if="shortPhone" class="myValidationText">Phone number must be 11 digits!</label>
             <v-input type="text" placeholder="E-Mail Address" v-on:keyup.native="saveForm" v-model="messageForm.email"/>
              <label for="email" v-if="falseEmail" class="myValidationText">Wrong email format!</label>
              <label for="email" v-if="emptyEmail" class="myValidationText">Can not be leave empty!</label>
                    </form>

                    <button class="button gray icon-left fw dorm-form__button" v-if="!isNumberShow && !isShowFormMobile && !showSuccessMessage" @click="showNumber">
                      <span class="button__wrp">
                        <span class="button__icon">
                          <svg class="icon">
                            <use xlink:href="/icon/icons.svg#icon-headphone"></use>
                          </svg>
                        </span>
                        <span class="button__txt">CAll</span>
                      </span>
                    </button>

                    <button v-if="isNumberShow && !isShowFormMobile && !showSuccessMessage" class="button gray icon-left fw dorm-form__button">
                      <a :href="'tel:' + phone"><span class="button__wrp">
                        <span class="button__icon">
                          <svg class="icon">
                            <use xlink:href="/icon/icons.svg#icon-headphone"></use>
                          </svg>
                        </span>
                        <span class="button__txt">{{ phone }}</span>
                      </span>
                     </a></button>

                    <button class="button green icon-left fw dorm-form__button" @click="sendWhatsappMessage" v-if="!isShowFormMobile && !showSuccessMessage">
                        <span class="button__wrp">
                            <span class="button__icon">
                                <svg class="icon">
                                    <use xlink:href="/icon/icons.svg#icon-whatsapp"></use>
                                </svg>
                            </span>
                            <span class="button__txt">RENT MOVIE</span>
                        </span>
                    </button>

                </div>
                <div class="fixed-mobile__bottom">
                    <button class="button red fw dorm-form__submit" v-if="!isShowFormMobile && !showSuccessMessage" @click="toggleMobileForm"><span class="button__wrp"><span class="button__txt">
                    LEARN RENT PRICE
                        </span></span>
                    </button>
                    <button class="button red fw dorm-form__submit" v-if="isShowFormMobile && !showSuccessMessage" @click="submitForm"><span class="button__wrp"><span class="button__txt">
                    SEND
                </span></span>
                    </button>
                </div>

            </div>

        <!--<v-link-->
        <!--to="/"-->
        <!--@click.native="goBack"-->
        <!--class="dorm__back"-->
        <!--icon="icon-arrow-long-left"-->
        <!--icon-position="left"-->
        <!--/>-->
  <Modal2 :active="showVirtualTour" @onModalClose="closeModalVirtualTour">
   <div slot="content">
 <iframe width="1024" height="768" class="ql-video" frameborder="0" allowfullscreen="true" :src="virtual_tour"></iframe>'   
</div>
</Modal2>        
        <Modal2 :active="showModal" @onModalClose="closeModal">
            <div slot="content">
                <div class="login-box" style="margin: 0 auto">
                    <span class="close" ref="close" v-on:click="closeModal">&times;</span>
                    <h3 class="login-box__title">USER LOGIN</h3>
                    <v-input ref="input1" placeholder="E-mail adresiniz" v-model="loginForm.email" />
                    <label for="password" v-if="falseEmail2" class="myValidationText" required>Wronr email format!</label>
                    <label for="password" v-if="emptyEmail2" class="myValidationText">Can not be leave empty!</label>
                    <span class="text-danger"></span>
                    <v-input ref="input2" placeholder="Şifreniz" type="password" v-model="loginForm.password" />
                    <label for="password" v-if="emptyPassword" class="myValidationText">Can not be leave empty!</label>
                    <router-link class="password-forget" to="/sifremi-unuttum"> I Lost My Password</router-link>
                    {{error}}
                    <v-button class="green fw shadow-none login-box__submit" @click.native="login" title="LOGIN" />
                    <div class="or">
                        <p><span class="mycolorBlue">Are you new at</span><span class="mycolor2">.com</span>Holywood Skyline?</p>
                    </div>
                    <v-button class="gray fw shadow-none login-box__submit" @click.native="register" title="REGISTER" />
                </div>
            </div>
        </Modal2>
 <Modal2 :active="showSuccessMessage" @onModalClose="closeSuccessMessage">
   <div slot="content">
     <div class="login-box" style="margin: 0 auto">
       <span class="close" ref="close" v-on:click="closeSuccessMessage">&times;</span>
        <div class="clear"></div>
    <h2 class="login-box__title" >MESSAGE SENT!</h2>
    <div class="or">
      <p ><span class= "mycolorBlue">Thanks for your interest.</span></p>
      <p ><span class= "mycolorBlue">Our friend will contact you soon.</span></p>
    </div>
     </div>
</div>
</Modal2>
        <div class="dorm__inner">
            <div class="dorm-top__wrp" ref="dormContent">
                <div>&nbsp;</div>
                <container>
                    <div class="dorm-top">
                        <div class="dorm-top__content">
                            <div class="dorm-header">
                                <div slot="bread">
<ol itemscope itemtype="https://schema.org/BreadcrumbList">
<li class="mytitle1 myli" itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem">
<a href="https://holywoodskyline.com/" class="" itemtype="https://schema.org/Thing" itemprop="item">
<span itemprop="name">holywoodskyline.com</span>
<span>&nbsp;/&nbsp;</span>
</a>
<meta itemprop="position" content="1" />
</li>

<li class="color-white mytitle1 myli" itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem">
<a :href="city_url" class="" itemtype="https://schema.org/Thing" itemprop="item">
&nbsp;<span itemprop="name">{{profession}}s</span>
</a>
<meta itemprop="position" content="2" />
</li>

<li class="color-white mytitle1 myli" itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem">
<a :href="district_url" class="" itemtype="https://schema.org/Thing" itemprop="item">
&nbsp;<span class="mysize">&nbsp;/&nbsp;</span>
&nbsp;<span itemprop="name">{{ detail.name }} </span>
</a>
<meta itemprop="position" content="3" />
</li>
</ol>

                                </div>
                                <div class="dorm-header__top" v-if="detail">
<!--                                     <div class="dorm-header-logo" v-if="detail.dorm.logo">
                                        <img :src="detail.dorm.logo" alt="" class="dorm-header-logo__img">
                                    </div> -->

                                    <div class="dorm-header__content" v-if="detail">
                                        <div class="dorm-header__title">{{ detail.name }}</div>
                                        <div class="dorm-header-loc">
                                            <span class="dorm-header-loc__icon">
                    <svg-icon type="icon-location" />
                  </span>
                                            <div class="dorm-header-loc__title">
                                                {{ detail.place_of_birth }}, {{ detail.birthday }}</div>
                                        </div>
                                    </div>
                                    <!--                 <div class="dorm-header-price">
                  <div class="dorm-header-price__title">
                    290.000 TL
                  </div>
                  <span class="dorm-header-price__txt">
                  'den başlayan oda fiyatları
                </span>
                </div> -->

                                    <div class="right-mobile" style="display: none">
                                        <div class="dorm-form-buttons">
                                            <button v-on:click="setFavorite()" class="button dorm-form-buttons__item circle round" :class="[{'white blue': !isFavorite,'red addedFavorite': isFavorite}]" ><span class="button__wrp"><span
                      class="button__icon"><svg class="icon"><use
                      xlink:href="/icon/icons.svg#icon-heart"></use></svg></span></span>
                                            </button>
                                            <button v-on:click="showShare()" class="button dorm-form-buttons__item circle round" :class="[{'white blue': !isShare,'green white sharedOn': isShare}]"><span class="button__wrp"><span
                      class="button__icon"><svg class="icon"><use
                      xlink:href="/icon/icons.svg#icon-share"></use></svg></span></span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
      <ContentLoader v-if="!videos"
      :height="700"
      :width="500">
        <rect x="2" y="20" rx="3" ry="3" width="80" height="40" />        
        <rect x="2" y="70" rx="3" ry="3" width="500" height="320" />
        <rect x="2" y="400" rx="3" ry="3" width="75" height="60" />
        <rect x="85" y="400" rx="3" ry="3" width="75" height="60" /> 
        <rect x="170" y="400" rx="3" ry="3" width="75" height="60" />
        <rect x="255" y="400" rx="3" ry="3" width="75" height="60" />
        <rect x="340" y="400" rx="3" ry="3" width="75" height="60" />
        <rect x="425" y="400" rx="3" ry="3" width="75" height="60" />               
      </ContentLoader>                                 
                                <div class="dorm-gallery">
                                    <div class="gallery" v-if="videos">
                                        <GalleryThumbPerson :gallery="videos" :hasVideo="hasVideo" v-if="videos.length > 0" />
                                        <div class="dorm-gallery-empty" v-if="!videos || videos.length === 0">
                                            <img src="@/assets/img/holywoodskyline-default.jpg" alt="" class="dorm-gallery-empty__img">
                                        </div>


                                    </div>
                                </div>
   <social-sharing  v-if="showShareButtons"
                      :url="this.url"
                      :title="this.name"
                      :description="this.description"
                      :quote="this.name"
                      hashtags="holywoodskyline"
                      :twitter-user="this.twitter_user"
                      inline-template>
                      <div class="dorm-form__wrp mysharebuttons ">
  <div class="icon-font">
      <network network="facebook">
      <span class="icon-font mybutton">
        <svg-icon type="icon-facebook" />
      </span>
      </network>
      <network network="twitter">
      <span class="icon-font mybutton">
        <svg-icon type="icon-twitter" />
      </span>
      </network>
      <network network="whatsapp">
      <span class="icon-font mybutton ">
        <svg-icon type="icon-whatsapp" />
      </span>
      </network>

      <network network="email">
      <span class="icon-font mybutton">
        <svg-icon type="icon-mail" />
      </span>
      </network>
  </div>
  </div>

</social-sharing>
                                <div class="dorm-header__bottom">
                                    <div class="dorm-header-inf" v-if="detail">
                                        <div class="dorm-header-inf__item" v-if="detail.capacity">
                                            <span class="dorm-header-inf__icon">
                      <svg-icon type="icon-bed" />
                    </span>
                                            <div class="dorm-header-inf__txt">{{ detail.capacity }} <i class="spc-text myfontstyle">Yatak</i></div>
                                        </div>

                                        <div class="dorm-header-inf__item" v-if="detail.meal">
                                            <span class="dorm-header-inf__icon">
                      <svg-icon type="icon-food"/>
                    </span>
                                            <div class="dorm-header-inf__txt">{{ detail.meal }} <i class="spc-text myfontstyle">Öğün</i></div>
                                        </div>

                                        <div class="dorm-header-inf__item" v-if="detail.is_wifi">
                                            <span class="dorm-header-inf__icon">
                      <svg-icon type="icon-wifi" />
                    </span>
                                            <div class="dorm-header-inf__txt"><i class="spc-text myfontstyle">Wi-Fi</i> Var</div>
                                        </div>
                                    </div>

                                    <div class="dorm-header-customer">
                                        <div class="dorm-header-customer__cnt">
                                            <div class="dorm-header-customer__name" v-if="member && member != 'null'">{{ member }}</div>
                                            <div class="dorm-header-customer__branch" v-if="member && member != 'null'">Yetkili Danışman</div>
                                        </div>
                                        <span class="dorm-header-customer__icon" v-if="member && member != 'null' ">
                    <svg-icon type="icon-headphone" />
                  </span>
                                    </div>
                                </div>
                            </div>
                            <div class="dorm-top__cnt" v-if="detail">
                                <div class="dorm-top-address">
                                    <span class="dorm-top-address__icon">
                  <svg-icon type="icon-location"/>
                </span>
                                    <div class="dorm-top-address__title">Homepage {{ detail.homepage }}</div>
                                </div>
                                <div class="dorm-top-address">
                                <!-- <a target="_blank" v-if="detail.dorm.web" :href="'http://' + detail.dorm.web">   -->
                                    <span class="dorm-top-address__icon" v-if="detail.homepage">
                  <svg-icon type="icon-web"/>
                </span>
                                    <span class="dorm-top-address__title">{{ detail.homepage }} <b v-if="detail.homepage">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</b></span>
                                    <!-- </a> -->
                                    
                                    <a v-if="detail.imdb_id" :href="'tel:' + detail.imdb_id">
                                      <span class="dorm-top-address__icon">
                  <svg-icon type="icon-phone1"/>
                </span>
                
                                <span class="dorm-top-address__title">Release Date {{ detail.release_date}}</span>                                    
                               </a>
                                </div>
                                <div class="myborder">
                                  </div>
                                   <p>&nbsp;</p> 

                                <div class="dorm-content-collapse" :style="{ height : collapseContent ? collapseContentHeight : '200px' }">
                                    <div class="dorm-top__txt" ref="dormContentText" v-html="detail.biography"></div>
                                </div>

                                <div class="lengthDots" v-if="detail.biography && detail.biography.length >= 450 && !collapseContent">
                                    ...
                                </div>
                                <v-button v-if="detail.biography && detail.biography.length >= 450" class="button--more dorm-top__button" @click.native="toggleContentText" :title="collapseContent ? 'Show less' : 'Read More'" :icon="collapseContent ? 'icon-arrow-up' : 'icon-arrow-long-right'" icon-position="right" />

                                  <p>&nbsp;</p> 
                                <div class="dorm-top-address__title">Crew List</div>
                                <div class="dorm-content-collapse" :style="{ height : collapseContent ? collapseContentHeight : '600px' }">
                                 <div  v-for="(tab, index) in credits.cast" :key="tab.id" :class="{'active': tab.isActive}">
                                <button class="dorm-top-address__title" :title="tab.job"  @click.native="tabSelect(index, tab.title)" />
                            <span class="dorm-top-address__title">{{tab.character}} </span><span class="dorm-top__txt">{{tab.name}}</span>
                            </div>
                                </div>
                                <v-button v-if="credits.crew && credits.crew.length >= 10" class="button--more dorm-top__button" @click.native="toggleContentText" :title="collapseContent? 'Hide Crew' : 'Show Crew'" :icon="collapseContent ? 'icon-arrow-up' : 'icon-arrow-long-right'" icon-position="right" />
</div>

<!--                             <div v-if="credits.crew">-->
                             <div  v-for="(tab, index) in credits.cast" :key="tab.id" :class="{'active': tab.isActive}">
                                <button class="dorm-top-address__title" :title="tab.job"  @click.native="tabSelect(index, tab.title)" />
                            <span class="dorm-top-address__title">{{tab.character}} </span><span class="dorm-top__txt">{{tab.name}}</span>
                            </div>
<!--
                             <div  v-for="(tab, index) in credits.crew" :key="tab.id" :class="{'active': tab.isActive}">
                                <button class="dorm-top-address__title" :title="tab.job"  @click.native="tabSelect(index, tab.title)" />
                            <span class="dorm-top-address__title">{{tab.job}} </span><span class="dorm-top__txt">{{tab.name}}</span>
                            </div>

                            </div> 
                            </div> -->
                        </div>
<!--                         <div class="dorm-top__left" ref="dormRight">
                            <DormForm v-if="showDormForm" :fixed-form="fixedForm" :form-offset="formOffset" :form-width="formWidth" :current-room="currentRoom" :current-price="currentPrice" :dormId="id" :phone1="phone" :phoneForMessage="phoneForMessage" :name="name" :description="description" :city_name="city_name" :district_name="district_name" :keywords="keywords" :dorm_slug="dorm_slug" ref="dormForm" />
                        </div> -->
                    </div>
                </container>
            </div>

            <div class="dorm__content">
                <div :class="{ stickyTab : stickyTab }" class="sticky-nav">
                    <container>
                        <div class="sticky-nav__list">
                            <div class="sticky-nav__item" v-for="(tab, index) in tabsMenu" :key="tab.id" :class="{'active': tab.isActive}">
                                <v-button class="sticky-nav__link" :title="tab.title" :class="{ 'active': tab.isActive }" @click.native="tabSelect(index, tab.title)" />
                            </div>
                        </div>
                    </container>
                </div>
            </div>
            <div class="sticky-nav__space"></div>
            <!--<div id="one" ref="paneOne">-->
            <!--<div class="mobile-gen-title"><p>Odalar</p></div>-->
            <!--<container>-->

            <!--<div class="dorm-room">-->
            <!--<dorm-accordion-item-->
            <!--v-for="room in rooms" :key="room.id"-->
            <!--:item="room"-->
            <!--@onPriceChange="changePrice"-->
            <!--/>-->
            <!--</div>-->
            <!--</container>-->
            <!--</div>-->
            <div id="one" class="property-wrp" ref="paneOne">

                <div class="mobile-gen-title">
                    <p>Service and Properties</p>
                </div>

                <container>
                    <div class="dorm-tabs col-xs-12 col-md-12 pad0-i">
                        <div class="dorm-tabs col-xs-12 col-md-8 pad0-i" v-if="detail">

                            <div v-for="property in properties" :key="property.id">
                                <dorm-property :dataServices="property" />
                            </div>

                        </div>
                    </div>
                </container>
            </div>

            <div id="two" class="dorm-comment-wrapper" ref="paneTwo">

                <div class="mobile-gen-title">
                    <p>Yorumlar</p>
                </div>
                <container>
                    <div class="comment col-xs-12 col-md-8">
                         <div>
                        <p>&nbsp;</p>
                         </div>

                        <div class="result-bracket__title">
                            <div v-if="comments.length !== 0">
                                <span class="result-bracket__count" v-if="comments.length !== 0">{{ comments.length }} </span> Reviews Found !
                            </div>
                            <EmptyComment :content="emptyContent" v-if="comments.length === 0" />
                        </div>
                        <div class="dorm-comment__item" v-for="comment in comments" :key="comment.id">
                            <div class="dorm-comment__item-gen">

                                <!-- <img :src="comment.image" class="dorm-comment__img" alt=""> -->
                                <avatar :fullname="comment.author" size=36 color="#4b5ba4"></avatar>
                                <div class="dorm-comment__content">
                                    <h3 class="dorm-comment__name">{{ comment.author }} </h3>
                                    <span class="dorm-comment__date">{{ comment.author }}</span>
                                    <p class="dorm-comment__text">
                                        {{ comment.content }}
                                    </p>
                                    <!--                 <div class="dorm-comment__reply">
<span class="dorm-comment__ico">
<svg-icon type="icon-enter"/>
</span>
                  <p class="dorm-comment__reply-text" @click="answer(comment.user.first_name + ' ' + comment.user.last_name)">Cevapla</p>
                </div> -->

                                </div>
                            </div>

                            <div class="dorm-comment__item--replies" v-for="reply in comment.replies" :key="reply.id">
                                <img :src="reply.image" class="dorm-comment__img" alt="">
                                <div class="dorm-comment__content">
                                    <h3 class="dorm-comment__name">{{ reply.user.first_name }}</h3>
                                    <span class="dorm-comment__date">{{ reply.created_at }}</span>
                                    <p class="dorm-comment__text">
                                        {{ reply.comment }}
                                    </p>
                                    <div class="dorm-comment__reply">
                                        <span class="dorm-comment__ico">
                        <svg-icon type="icon-enter"/>
                </span>
                                        <p class="dorm-comment__reply-text">Answer</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <form>
                            <div class="comment__reply-text">
                                <input ref="messageField" type="text" placeholder="Make First Comment!" class="comment__entry" v-model="this.answerName" v-if="comments.length === 0 && !isEmptyComment" required>
                                <input ref="messageField" type="text" placeholder="Write your comment here.." class="comment__entry" v-model="this.answerName" v-if="comments.length !== 0 && !isEmptyComment" required>
                                <input ref="messageField" type="text" placeholder="Please Dont Leave empty!" class="comment__entry mycolor2" v-model="this.answerName" v-if="isEmptyComment" required>
                                <span v-on:click="sendComment()" class="comment__reply-text--ico">
                <svg-icon type="icon-send"/>
            </span>
                            </div>
                        </form>
                    </div>
                </container>
                <div>
                <p>&nbsp;</p>
                <p>&nbsp;</p>
                <p>&nbsp;</p>
                </div>
                </div>
            <div id="three" ref="paneThree">
                <div class="dorm-map" v-if="showMap">
                    <div class="mobile-gen-title">
                        <p>Map</p>
                    </div>
                    <gmap-map :options="mapOptions" :center="center" :zoom="15" style="width: 100%; height: 500px" ref='mapRef'>
                        <gmap-info-window :options="infoOptions" :position="marker.position" :opened="infoWinOpen" @closeclick="infoWinOpen = false">
                            <div class="map-info" v-if="detail">
                                <span class="map-info__icon">
              <img src="@/assets/img/icon-male.svg" alt="" class="icon" v-if="detail.dorm.dorm_type_id == 1">
              <img src="@/assets/img/icon-female.svg" alt="" class="icon" v-if="detail.dorm.dorm_type_id == 2">
            </span>
                                <div class="map-info__content">
                                    <div class="map-info__name" v-if="detail.dorm.dorm_type_id == 2">{{ detail.name }}</div>
                                    <div class="map-info__nameBoys" v-if="detail.dorm.dorm_type_id == 1">{{ detail.name }}</div>
                                    <div class="map-info__address">
                                        {{detail.dorm.address }}
                                    </div>
                                </div>
                                <button class="button map-info__button">
                                    <span class="button__wrp">
                <a :href="mapurl" target="_blank" >
                    <span class="button__icon">
                  <img src="@/assets/img/get-directions.svg" alt="" class="icon">
                </span></a>
                <a :href="mapurl" target="_blank">
                                    <span class="button__txt">
                  Yol Tarifi Al
                </span></a>
                                    </span>
                                </button>
                            </div>
                        </gmap-info-window>

                        <gmap-marker :icon="require('@/assets/img/marker.png')" :position="marker.position" :clickable="true" @click="toggleInfoWindow()" v-if="detail.dorm.dorm_type_id == 2"></gmap-marker>
                        <gmap-marker :icon="require('@/assets/img/marker-male.png')" :position="marker.position" :clickable="true" @click="toggleInfoWindow()" v-if="detail.dorm.dorm_type_id == 1"></gmap-marker>
                    </gmap-map>
                </div>
            </div>

                <div v-if="detail && branches.length > 0" class="city-uni dorm-slider" ref="dormSlider">
                    <container>
                        <div class="city-uni__wrp">
                            <div class="section__header">
                                <div class="section__title">
                                    <span class="color-light-green">Other</span> Serie Movies
                                </div>
                                <div class="section__right">
                                    <v-button icon="icon-arrow-left" icon-position="left" class="circle white icon-xs xs js-uni-slider-prev" />

                                    <v-button icon="icon-arrow-right" icon-position="left" class="circle white icon-xs xs js-uni-slider-next" />
                                </div>
                            </div>
                            <swiper class="city-uni-slider" v-if="detail" :options="swiperOption">
                                <swiper-slide v-for="dorm in branches" :key="dorm.id" class="city-uni-slider__item">
                                    <movie-card :movie="dorm" />
                                </swiper-slide>
                            </swiper>
                        </div>
                    </container>
                </div>

                <div class="city-uni dorm-slider" ref="dormSlider">
                    <container>
                        <div class="city-uni__wrp">
                            <div class="section__header">
                                <div class="section__title">
                                    <span class="color-light-green">Related</span> Movies
                                </div>
                                <div class="section__right">
                                    <v-button icon="icon-arrow-left" icon-position="left" class="circle white icon-xs xs js-uni-slider-prev" />

                                    <v-button icon="icon-arrow-right" icon-position="left" class="circle white icon-xs xs js-uni-slider-next" />
                                </div>
                            </div>
                            <swiper class="city-uni-slider" v-if="movies" :options="swiperOption">
                                <swiper-slide v-for="dorm in movies" :key="dorm.id" class="city-uni-slider__item">
                                    <dorm-card :dorm="dorm" />
                                </swiper-slide>
                            </swiper>                            
                            <swiper class="city-uni-slider" v-if="movies" :options="swiperOption">
                                <swiper-slide v-for="dorm in movies" :key="dorm.id" class="city-uni-slider__item">
                                    <person-card :dorm="dorm" />
                                </swiper-slide>
                            </swiper>
                        </div>
                    </container>
                </div>

            </div>
        </div>
</template>
<script>

import MovieCard from '@/components/MovieCard'
import PersonCard from '@/components/PersonCard'
import DormProperty from '@/components/DormProperty'
import GalleryThumbPerson from '@/components/GalleryThumbPerson'
// import DormForm from '@/components/Dorm/DormForm'
import axios from 'axios'
import Avatar from 'vue-avatar-component'
import SocialSharing from 'vue-social-sharing'
import VueInputRestricted from '@/components/VueInputRestricted'
import VueSelectTempUniversity from '@/components/VueSelectTempUniversity'
import VueSelectTempFaculty from '@/components/VueSelectTempFaculty'
import { ContentLoader } from 'vue-content-loader'
import {
  mapGetters
}
  from 'vuex'
import { mapState } from 'vuex'
import Modal2 from '@/components/Modal2'
import {
  SET_USER_INFO
}
  from '@/store/mutations.type'
import EmptyComment from '@/components/EmptyComment'
import Loading from 'vue-loading-overlay'
import SelectBox2old from '@/components/SelectBox2old'
export default {
  name: 'PersonDetail',
  components: {
    GalleryThumbPerson, MovieCard, PersonCard, DormProperty, Avatar, Modal2, EmptyComment, SocialSharing, VueInputRestricted, Loading, SelectBox2old, VueSelectTempUniversity, VueSelectTempFaculty, ContentLoader
  },
   MetaInfo () {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      //title: this.dorm_name + ' | ' + this.city_name + ' | ' + this.district_name,
      // title: this.settings ? this.settings.setting.title : '',
/*       meta: [
        { name: 'description', content: this.description ? this.description : '' },
        { name: 'keywords', content: this.keywords ? this.keywords : '' }
      ], */
      link: [
        { rel: 'canonical' },
        { href: this.page_url }
      ]

    }
  },
  data () {
    return {
      credits: null,
      movies: null,
      profession: 'Actors',
      errors: [],
      images: null,
      videos: [],
      virtual_tour: false,
      showVirtualTour: false,
      hasVideo: true,
      iframe: '',
      isLoading: false,
      fullPage: true,
      city_url: '',
      district_url: '',
      city_name: '',
      district_name: '',
      dorm_name: '',
      keywords: '',
      page_url: '',
      branches: [],
      showMobileBottom: false,
      dormProperties: [],
      showDormForm: true,
      showShareButtons: false,
      url: '',
      mapurl: '',
      name: '',
      description: '',
      keywords: '',
      twitter_user: '',
      // emptyEmail: false,
      falseEmail2: false,
      emptyPassword: false,

      falseEmail: false,
      falsePhone: false,
      shortPhone: false,
      emptyName: false,
      emptyPhone: false,
      emptyEmail: false,
      emptyEmail2: false,
      emptyUniversity: false,
      emptyFaculty: false,
      loginForm: {
        email: null,
        password: null
      },
      isFavorite: false,
      showModal: false,
      favorites: [],
      errors: [],
      universities: null,
      faculties: null,
      showSuccessMessage: false,
      isShowFormMobile: false,
      isNumberShow: false,
      isEmptyComment: false,
      dene1: [],
      showModal: false,
      messageForm: {
        dorm_id: null,
        name: '',
        email: '',
        university_id: '',
        faculty_id: '',
        phone: '',
        university_name: 'Üniversite Seç',
        faculty_name: 'Fakülte Seç'
      },
      emptyContent: {
        icon: 'icon-yorum-yok',
        title: 'No Result!',
        text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Assumenda dolor, dolorem fugit in quis velit!'
      },
      properties: [{
        created_at: '2018-12-16 18:37:00',
        id: 1,
        properties: [],
        title: 'Bina Özellikleri',
        updated_at: '2018-12-16 18:37:00'
      }, {
        created_at: '2018-12-16 18:37:00',
        id: 2,
        properties: [],
        title: 'Oda Özellikleri',
        updated_at: '2018-12-16 18:37:00'
      }, {
        created_at: '2018-12-16 18:37:00',
        id: 3,
        properties: [],
        title: 'Hizmetler',
        updated_at: '2018-12-16 18:37:00'
      }],
      center: {
        lat: 0,
        lng: 0
      },
      id: null,
      phone: null,
      phoneForMessage: null,
      member: '',
      infoWindowPos: null,
      infoWinOpen: true,
      currentMidx: null,
      showMap: null,
      mapOptions: {
        styles: [{
          'featureType': 'administrative',
          'elementType': 'geometry.fill',
          'stylers': [{
            'color': '#d6e2e6'
          }]
        }, {
          'featureType': 'administrative',
          'elementType': 'geometry.stroke',
          'stylers': [{
            'color': '#cddbe0'
          }]
        }, {
          'featureType': 'administrative',
          'elementType': 'labels.text.fill',
          'stylers': [{
            'color': '#4a5aa3'
          }]
        }, {
          'featureType': 'administrative.neighborhood',
          'elementType': 'labels.text.fill',
          'stylers': [{
            'lightness': 25
          }]
        }, {
          'featureType': 'administrative.land_parcel',
          'elementType': 'labels',
          'stylers': [{
            'visibility': 'off'
          }]
        }, {
          'featureType': 'landscape.man_made',
          'elementType': 'geometry.fill',
          'stylers': [{
            'color': '#edf0f8'
          }]
        }, {
          'featureType': 'landscape.man_made',
          'elementType': 'geometry.stroke',
          'stylers': [{
            'color': '#d8dce2'
          }]
        }, {
          'featureType': 'landscape.natural',
          'elementType': 'geometry.fill',
          'stylers': [{
            'color': '#edf0f8'
          }]
        }, {
          'featureType': 'landscape.natural',
          'elementType': 'labels.text.fill',
          'stylers': [{
            'color': '#7492a8'
          }]
        }, {
          'featureType': 'landscape.natural.terrain',
          'elementType': 'all',
          'stylers': [{
            'visibility': 'off'
          }]
        }, {
          'featureType': 'poi',
          'elementType': 'geometry.fill',
          'stylers': [{
            'color': '#edf0f8'
          }]
        }, {
          'featureType': 'poi',
          'elementType': 'labels.text.fill',
          'stylers': [{
            'color': '#588ca4'
          }]
        }, {
          'featureType': 'poi', // places icons
          'elementType': 'labels.icon',
          'stylers': [{
            'saturation': 100
          }]
        }, {
          'featureType': 'poi.park',
          'elementType': 'geometry.fill',
          'stylers': [{
            'color': '#cae7a8'
          }]
        }, {
          'featureType': 'poi.park',
          'elementType': 'geometry.stroke',
          'stylers': [{
            'color': '#bae6a1'
          }]
        }, {
          'featureType': 'poi.sports_complex',
          'elementType': 'geometry.fill',
          'stylers': [{
            'color': '#c6e8b3'
          }]
        }, {
          'featureType': 'poi.sports_complex',
          'elementType': 'geometry.stroke',
          'stylers': [{
            'color': '#bae6a1'
          }]
        }, {
          'featureType': 'road',
          'elementType': 'labels.text.fill',
          'stylers': [{
            'color': '#41626b'
          }]
        }, {
          'featureType': 'road',
          'elementType': 'labels.icon',
          'stylers': [{
            'saturation': -45
          }, {
            'lightness': 10
          }, {
            'visibility': 'off'
          }]
        }, {
          'featureType': 'road.highway',
          'elementType': 'geometry.fill',
          'stylers': [{
            'color': '#f7fdff'
          }]
        }, {
          'featureType': 'road.highway',
          'elementType': 'geometry.stroke',
          'stylers': [{
            'color': '#beced4'
          }]
        }, {
          'featureType': 'road.arterial',
          'elementType': 'geometry.fill',
          'stylers': [{
            'color': '#ffffff'
          }]
        }, {
          'featureType': 'road.arterial',
          'elementType': 'geometry.stroke',
          'stylers': [{
            'color': '#dadee4'
          }]
        }, {
          'featureType': 'road.local',
          'elementType': 'geometry.fill',
          'stylers': [{
            'color': '#ffffff'
          }]
        }, {
          'featureType': 'road.local',
          'elementType': 'geometry.stroke',
          'stylers': [{
            'color': '#dadee4'
          }]
        }, {
          'featureType': 'road.local',
          'elementType': 'labels',
          'stylers': [{
            'visibility': 'off'
          }]
        }, {
          'featureType': 'transit',
          'elementType': 'labels.icon',
          'stylers': [{
            'saturation': -70
          }]
        }, {
          'featureType': 'transit.line',
          'elementType': 'labels.text.fill',
          'stylers': [{
            'color': '#588ca4'
          }]
        }, {
          'featureType': 'transit.station',
          'elementType': 'labels.text.fill',
          'stylers': [{
            'color': '#008cb5'
          }]
        }, {
          'featureType': 'transit.station.airport',
          'elementType': 'geometry.fill',
          'stylers': [{
            'saturation': -100
          }, {
            'lightness': -5
          }]
        }, {
          'featureType': 'water',
          'elementType': 'geometry.fill',
          'stylers': [{
            'color': '#a6cbe3'
          }]
        }]
      },
      infoOptions: {
        maxWidth: 530,
        pixelOffset: {
          width: 150,
          height: -22
        }
      },
      marker: {
        position: {
          lat: 0,
          lng: 0
        }
      },
      isShare: false,
      isActive: false,
      formWidth: null,
      collapseContent: false,
      collapseContentCrew: true,
      collapseContentHeight: null,
      stickyTab: false,
      currentPrice: null,
      currentRoom: null,
      fixedForm: false,
      formOffset: {
        top: 23 + 'px',
        left: 0
      },
      currentTab: 0,
      fixed: false,
      showForm: true,
      selected: null,
      swiperOption: {
        slidesPerView: 4,
        speed: 500,
        spaceBetween: 20,
        breakpoints: {
          768: {
            slidesPerView: 2,
            centeredSlides: false,
            slidesPerGroup: 2
          },
          640: {
            slidesPerView: 1,
            centeredSlides: false,
            slidesPerGroup: 1
          }
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.js-uni-slider-next',
          prevEl: '.js-uni-slider-prev'
        }
      },
      tabs: [{
        id: 0,
        title: 'DÖNEMLİK',
        active: true
      }, {
        id: 1,
        title: 'DAILY',
        active: false
      }],
      answerName: '',
      comments: [],
      tabsMenu: [],
      detail: {title: '', dorm:{capacity: 1, content: []}, biography: null, capacaity:1, meail:true, is_wifi:true},
      credits: {cast: null, crew:null},
      similarMovies: null,
      errors: null,
      biography: null
    }
  },
  methods: {
    closeModalVirtualTour() {
      this.showVirtualTour = false
    },
    mobileCheck() {
  var check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check
    },  
    validateEmail (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(String(email).toLowerCase())
    },
    showShare () {
      this.isShare = !this.isShare
      this.showShareButtons = !this.showShareButtons
    },
    getFavorites () {
      let self = this
      axios.get(`/user/favorites`)
        .then(response => {
          self.favorites = response.data.favorites
          let isFavorite = self.favorites.find(function (dorm) { return dorm.id == window.localStorage.getItem('dormid') })
          let dene = this.dormId
          if (isFavorite) {
            this.isFavorite = true
          }
        })
        .catch(e => {
          self.errors.push(e)
        })
      // console.log('1 favori: ' + self.favorites[0]. location)
    },
    setFavorite () {
      if (this.isLogin === '') {
        this.showModal = true
      } else {
        if (!this.isFavorite) {
          axios.post(`/site/dorm/favorite/${this.dormId}`, {
          })
        } else {
          axios.post(`/site/dorm/unfavorite/${this.dormId}`, {
          })
        }
        this.isFavorite = !this.isFavorite
      }
    },
    submitForm () {
      this.falseEmail = false
      this.falsePhone = false
      this.shortPhone = false
      this.emptyName = false
      this.emptyPhone = false
      this.emptyEmail = false
      this.emptyUniversity = false
      this.emptyFaculty = false
      let email = this.messageForm.email
      const verifiedMail = this.validateEmail(email)
      var self = this

      if (!this.messageForm.email) {
        this.emptyEmail = true
      } else if (this.messageForm.email && !verifiedMail) {
        this.falseEmail = true
      }
      if (!this.messageForm.name) {
        this.emptyName = true
      }
      if (!this.messageForm.phone) {
        this.emptyPhone = true
      }

      if (this.messageForm.phone && !this.messageForm.phone.startsWith('0')) {
        this.falsePhone = true
      }

      if (this.messageForm.phone && !this.falsePhone && this.messageForm.phone.length != 11) {
        this.shortPhone = true
      }

      if (!this.messageForm.university_id) {
        this.emptyUniversity = true
      }
      if (!this.messageForm.faculty_id) {
        this.emptyFaculty = true
      }

      if (!this.emptyName && !this.emptyEmail && !this.falseEmail && verifiedMail && !this.emptyPhone && !this.falsePhone && !this.shortPhone && !this.emptyUniversity) {
          let self = this
          const dorm_id = this.id
          axios.post(`/site/dorm/message/${dorm_id}`, {
          // data: this.messageForm
            name: this.messageForm.name,
            email: this.messageForm.email,
            phone: this.messageForm.phone,
            university_id: this.messageForm.university_id,
            faculty_id: this.messageForm.faculty_id,
            dorm_id: this.messageForm.dorm_id
          })
            .then(response => {
              if (response.status === 200 || response.status === 201) {
                self.showSuccessMessage = true
              } else {
                self.showErrorMessage = true
              }
            })
            .catch(error => {
              if (error.response) {
                this.showErrorMessage = true
              }
            })
        //}
      }
    },
    sendWhatsappMessage () {
      // this.isMessage = true
      window.open('https://wa.me/' + this.phoneForMessage + '?text=Hi,%20we%20reached%20you%20via%20holywodskyline.com%20', '_blank')
    },
    showNumber () {
      this.isNumberShow = true
    },
    toggleMobileForm () {
      this.showSuccessMessage = false
      this.showErrorMessage = false
      this.isShowFormMobile = !this.isShowFormMobile
    },
    closeSuccessMessage () {
      this.showSuccessMessage = false
      this.isShowFormMobile = false
    },
    selectUniversity (opt) {
      this.university_id = opt.id
      this.messageForm.university_id = opt.id
      window.localStorage.setItem('university_name', opt.name)
      window.localStorage.setItem('university_id', opt.id)
      let self = this
      axios.get(`/selected/faculties/${opt.id}`)
        .then(response => {
          self.faculties = response.data
        })
        .catch(e => {
          this.errors.push(e)
        })
      // this.saveForm()
    },
    selectFaculty (opt) {
     this.messageForm.faculty_id = opt.id
      window.localStorage.setItem('faculty_name', opt.name)
      window.localStorage.setItem('faculty_id', opt.id)
    },
    register () {
      this.$router.push('/kayit-ol')
    },
    login () {
      /*       if (this.validateForm()) {
                console.log('formValidated');
                //submit form to backend
            }

      this.validate()
      */

      this.emptyEmail2 = false
      this.falseEmail2 = false
      this.emptyPassword = false

      const verifiedMail = this.validateEmail(this.loginForm.email)
      if (!this.loginForm.password) {
        this.emptyPassword = true
      }
      if (!this.loginForm.email) {
        this.emptyEmail2 = true
      } else if (!this.emptyEmail2 && !verifiedMail) {
        this.falseEmail2 = true
      }

      if (verifiedMail && this.loginForm.password) {
        var self = this
        /*       if(!this.valid) {
        // this.email = 'Mail giriniz'
        this.$refs.input1.value = 'Mail giriniz'
      } */
        // if(this.valid) {
        axios.post(`/user/login`, {
          email: this.loginForm.email,
          password: this.loginForm.password
        })
          .then(response => {
            if (response.status === 200 || response.status === 201) {
              // self.showSuccessMessage = true
              // self.commit(SET_USER_INFO, response.data.user)
              self.$store.commit(SET_USER_INFO, response.data.user)
              const data = { updateLogin: true, isLogin: 'true' }
              self.$store.commit(SET_USER_INFO, data)
              self.$router.push(this.$route.params.slug + '-y-' + this.dormId)
              this.closeModal()
              window.localStorage.setItem('first_name', response.data.user.first_name)
              window.localStorage.setItem('last_name', response.data.user.last_name)
              window.localStorage.setItem('isLogin', 'true')
              window.localStorage.setItem('access_token', response.data.token)
              window.localStorage.setItem('mail', response.data.user.email)
              window.localStorage.setItem('username', response.data.user.first_name + ' ' + response.data.user.last_name)
              window.localStorage.setItem('access_token', response.data.token)
              window.localStorage.setItem('mail', response.data.user.email)
              window.localStorage.setItem('phone1', response.data.user.phone)
              window.localStorage.setItem('university_id', response.data.user.university_id)
              window.localStorage.setItem('faculty_id', response.data.user.faculty_id)

              self.setUniversityName(response.data.user.university_id, response.data.user.faculty_id)

              this.messageForm.name = window.localStorage.getItem('username')
              this.messageForm.email = window.localStorage.getItem('mail')
              this.messageForm.university_id = window.localStorage.getItem('university_id')
              this.messageForm.faculty_id = window.localStorage.getItem('faculty_id')

              this.isFavorite = true
              // document.cookie = "username=response.data.user.first_name; expires=Thu, 18 Dec 2019 12:00:00 UTC";
            } else {
              self.showErrorMessage = true
            }
          })
          .catch(error => {
            if (error.response) {
              this.showErrorMessage = true
              // console.log('hata: ' + error.response)
            }
          })
      }
    },
    /*     limitStr (string, limit) {
                  let str = string;

                  if (typeof str === 'string' && str.length > limit) {
                    str = str.slice(0, limit) + '...'
                  }
                  return str
                }, */
    closeModal () {
      this.showModal = false
    },
    closeModaSuccess () {
      this.showSuccessMessage = false
    },
    updateTabs () {
      if (this.showMap && this.dormProperties.length > 0 && this.detail.dorm.virtual_tour && !this.mobileCheck()) {
        this.tabsMenu = [{
          id: 1,
          title: 'Özellikler',
          link: '#ozellikler',
          isActive: true
        }, {
          id: 2,
          title: 'Yorumlar',
          link: '#yorumlar',
          isActive: false
        }, {
          id: 3,
          title: 'Harita',
          link: '#Harita',
          isActive: false
        }, {
          id: 4,
          title: 'Sanal Tur',
          link: '#Sanal',
          isActive: false
        }        
        ]
      } else if (this.showMap && this.dormProperties.length > 0) {
        this.tabsMenu = [{
          id: 1,
          title: 'Özellikler',
          link: '#ozellikler',
          isActive: true
        }, {
          id: 2,
          title: 'Yorumlar',
          link: '#yorumlar',
          isActive: false
        }, {
          id: 3,
          title: 'Harita',
          link: '#Harita',
          isActive: false
        }]
      }
      else if (this.showMap && this.dormProperties.length === 0 && this.detail.dorm.virtual_tour) {
        this.tabsMenu = [{
          id: 1,
          title: 'Yorumlar',
          link: '#yorumlar',
          isActive: true
        }, {
          id: 2,
          title: 'Harita',
          link: '#harita',
          isActive: false
        },
      {
          id: 3,
          title: 'Sanal Tur',
          link: '#Sanal',
          isActive: false
        },        
        ]
      }      
      else if (this.showMap && this.dormProperties.length === 0) {
        this.tabsMenu = [{
          id: 1,
          title: 'Yorumlar',
          link: '#yorumlar',
          isActive: true
        }, {
          id: 2,
          title: 'Harita',
          link: '#harita',
          isActive: false
        }]
      } else if (!this.showMap && this.dormProperties.length === 0 && this.detail.dorm.virtual_tour) {
        this.tabsMenu = [{
          id: 1,
          title: 'Yorumlar',
          link: '#yorumlar',
          isActive: true
        },
      {
          id: 2,
          title: 'Sanal Tur',
          link: '#Sanal',
          isActive: false
        }        ]
      } else if (!this.showMap && this.dormProperties.length === 0) {
        this.tabsMenu = [{
          id: 1,
          title: 'Yorumlar',
          link: '#yorumlar',
          isActive: true
        }]
      } else {
        this.tabsMenu = [{
          id: 1,
          title: 'Özellikler',
          link: '#ozellikler',
          isActive: true
        }, {
          id: 2,
          title: 'Yorumlar',
          link: '#yorumlar',
          isActive: false
        }]
      }
    },
    sendComment: function () {
      if (this.isLogin === '') {
        this.showModal = true
        // var modal = this.$refs.myModal
        // modal.style.display = "block"
      } else {
        if (!this.$refs.messageField.value) {
          this.isEmptyComment = true
        } else {
          this.isEmptyComment = false
          // console.log(this.$refs.messageField.value)
          const mytoken = window.localStorage.getItem('access_token')
          const id = window.localStorage.getItem('dormid')
          axios.post(`/site/dorm/comment/${this.id}`, {
            token: mytoken,
            comment: this.$refs.messageField.value
          }).then(response => {
            this.$refs.messageField.value = ''

            let self = this
            let dormID = this.$route.params.slug
            dormID = dormID.split('-').reverse()[0]
            const url = self.$attrs.redirect ? `/site/dorm/detail/${dormID}` : `/site/dorm/detail/${this.$route.params.id}`
            axios.get(url)
              .then(response => {
                self.comments = response.data.dorm.comments.reverse()
                self.comments.forEach((item) => {
                  const str = item.created_at.split(':')
                  item.created_at = str[0] + ':' + str[1]
                })
              })
              .catch(e => {
                self.errors.push(e)
              })
          })

          //      this.$refs.messageField.value = ''
        }
      }
    },
    tabSelect (index, title) {
if(title === 'Sanal Tur') {
this.showVirtualTour = true
} else {
if (!this.showMap && this.dormProperties.length === 0) {
        this.tabsMenu[0].isActive = true
      } else {
        this.tabsMenu[1].isActive = false
      }
      if (this.dormProperties.length > 0) {
        this.tabsMenu[0].isActive = false
      }
      // this.tabsMenu[0].isActive = false

      if (this.showMap && this.dormProperties.length > 0) {
        this.tabsMenu[2].isActive = false
      } else if (this.showMap && this.dormProperties.length === 0) {
        this.tabsMenu[1].isActive = false
      }
      this.tabsMenu[index].isActive = true

      if (index === 0) {
        window.scrollTo({
          top: this.$refs.paneOne.offsetTop - 90,
          left: 0,
          behavior: 'smooth'
        })
      } else if (this.dormProperties.length === 0 && index === 1) {
        // özellikler yok harita var
        this.tabsMenu[1].isActive = true
        window.scrollTo({
          // top: this.$refs.paneTwo.offsetTop - 80,
          top: this.$refs.paneThree.offsetTop - 70,
          left: 0,
          behavior: 'smooth'
        })
      } else if (this.dormProperties.length > 0 && index === 1) {
        // if(self.comments.length > 0) yoruma göre offset top depğişebilir
        window.scrollTo({
          top: this.$refs.paneTwo.offsetTop - 80,
          // top: this.$refs.paneThree.offsetTop - 70,
          left: 0,
          behavior: 'smooth'
        })
      } else if (index === 2) {
        window.scrollTo({
          top: this.$refs.paneThree.offsetTop - 70,
          left: 0,
          behavior: 'smooth'
        })
      }
}
    },
    toggleInfoWindow () {
      this.infoWinOpen = !this.infoWinOpen
      // console.log('clicked on marker')
    },
    toggleContentText () {
      this.collapseContent = !this.collapseContent
      this.collapseContentHeight = this.$refs.dormContentText.offsetHeight + 'px'
    },
    toggleCrewText () {
      this.collapseContentCrew = !this.collapseContentCrew
      this.collapseContentHeight = this.$refs.dormContentText.offsetHeight + 'px'
    },    
    changePrice (item, price) {
      this.currentRoom = item
      this.currentPrice = price
    },
    tabShow (id) {
      this.tabs.forEach((item) => {
        item.active = false
      })
      this.tabs[id].active = true
    },
    answer (reply) {
      this.answerName = '@' + reply + ' '
    },
    setOffsets () {
      this.formWidth = this.$refs.dormRight.offsetWidth
    },
    handleScroll () {
      if (window.scrollY > 110 && window.scrollY < 2200) {
        this.showMobileBottom = true
      } else {
        this.showMobileBottom = false
      }
      let windowY = window.scrollY
      const paneOne = this.$refs.paneOne
      const paneTwo = this.$refs.paneTwo
      const paneThree = this.$refs.paneThree
      const dormSlider = this.$refs.dormSlider

      const dormForm = this.$refs.dormForm
      const contentOffsetTop = this.$refs.dormContent.offsetTop
      const contentOffsetLeft = this.$refs.dormContent.offsetLeft + this.$refs.dormRight.offsetLeft

      // if (windowY + 350 >= contentOffsetTop && windowY + 350 <= (dormSlider.offsetTop - dormForm.$el.offsetHeight)) {
      if (windowY >= contentOffsetTop && windowY <= (dormSlider.offsetTop - dormForm.$el.offsetHeight)) {
        this.fixedForm = true
        this.formOffset.left = contentOffsetLeft + 'px'
        this.formOffset.top = 10 + 'px'
        this.formOffset.position = 'fixed'
      } else if (windowY > (dormSlider.offsetTop - dormForm.$el.offsetHeight)) {
        // let w = window.scrollY
        // this.fixedForm = true
        this.formOffset.left = 0
        // this.formOffset.top = 23 + 'px'
        // this.formOffset.position = 'absolute'

        this.formOffset.top = (dormSlider.offsetTop - dormForm.$el.offsetHeight - 125) + 'px'
        this.formOffset.position = 'absolute'
      } else {
        this.fixedForm = true
        this.formOffset.left = 0
        this.formOffset.top = 23 + 'px'
        this.formOffset.position = 'absolute'
      }

      // sections
      if (windowY >= paneOne.offsetTop - 80 && windowY < paneTwo.offsetTop - 80) {
        this.currentTab = 0
        this.stickyTab = true
        if(this.tabsMenu[0]) {
          this.tabsMenu[0].isActive = true
        }
        if(this.tabsMenu[0]) {
          this.tabsMenu[1].isActive = false
        }
        

        if (this.showMap) {
          this.tabsMenu[2].isActive = false
        }
      } else if (this.showMap && windowY >= paneTwo.offsetTop - 120 && windowY < paneThree.offsetTop - 80) {
        this.currentTab = 1
        this.stickyTab = true
        if (this.dormProperties.length > 0) {
          this.tabsMenu[0].isActive = false
          this.tabsMenu[1].isActive = true
          this.tabsMenu[2].isActive = false
        } else {
          this.tabsMenu[0].isActive = true
          this.tabsMenu[1].isActive = false
        }
      } else if (windowY >= paneThree.offsetTop - 75 && windowY < dormSlider.offsetTop) {
        this.currentTab = 2
        this.stickyTab = true
        if(this.tabsMenu[0]) {
          this.tabsMenu[0].isActive = false
        }
          

        if (this.dormProperties.length == 0 && this.showMap) {
          this.tabsMenu[1].isActive = true
        } else if (this.tabsMenu[1]){
          this.tabsMenu[1].isActive = false
        }
        if (this.showMap && this.tabsMenu[2]) {
          this.tabsMenu[2].isActive = true
        }
      } else if (windowY >= dormSlider.offsetTop) {
        this.stickyTab = false
      } else {
        this.stickyTab = false
      }
    },   
    getPersonCredits() {
      let self = this
      const url = `/3/person/${this.$route.params.id}/movie_credits?api_key=a11ac97c6bdb99adc0845654be0902a8`
      axios.get(url)
        .then(response => {
        self.credits = response.data.cast
        })
        .catch(e => {
          self.errors.push(e)
        })       
    },      
    getImages () {
      let self = this
      this.isLoading = true
      const url = `/3/person/${this.$route.params.id}/images?api_key=a11ac97c6bdb99adc0845654be0902a8`

      axios.get(url)
        .then(response => {
        self.videos = response.data.profiles     
        })
        .catch(e => {
          self.errors.push(e)
        })

    },
    getPersonDetails () {
      let self = this
      this.isLoading = true
      const url = `/3/person/${this.$route.params.id}?api_key=a11ac97c6bdb99adc0845654be0902a8`
      axios.get(url)
        .then(response => {
          this.isLoading = false          
          self.description = response.data.biography
          self.keywords = '' //response.data.dorm.keywords
          self.dorm_slug = '' //response.data.dorm.slug + '-y-' + response.data.dorm.id
          self.city_url = '/' // + response.data.dorm.city.slug + '-ozel-ogrenci-yurtlari/'
          self.district_url = '/'  //+ response.data.dorm.city.slug + '-' + response.data.dorm.district.slug + '-ilcesi-ogrenci-yurtlari/'
          self.dorm_name = response.data.name
          self.city_name = '' //response.data.dorm.city.name
          self.district_name = '' //response.data.dorm.district.name
          self.page_url = window.location.origin + '/' // + response.data.dorm.slug + '-y-' + response.data.dorm.id
          // 669 460 yapıldı du
          // let l = self.detail.dorm.content.length
          self.mapurl = 'https://www.google.com/maps/dir//' // + response.data.dorm.lat + ',' + response.data.dorm.lng // 40.768319,30.416167'/
          // self.mapurl = 'https://maps.googleapis.com/maps/api/place/nearbysearch/json?type=university&location='+ response.data.dorm.lat + ',' + response.data.dorm.lng + '&radius=500&key=AIzaSyDYd2ezpHJldbKmnSC5WAkD4V-Uv3NAuYk'
          self.name = response.data.name
        })
        .catch(e => {
          self.errors.push(e)
        })
    },
    goBack () {
      this.$router.go(-1)
    }, 
    string_to_slug (str) {
      str = str.replace(/^\s+|\s+$/g, '') // trim
      str = str.toLowerCase()

      // remove accents, swap ñ for n, etc
      var from = 'àáäâèéëêìíïîòóöôùúüûñç·/_,:;'
      var to = 'aaaaeeeeiiiioooouuuunc------'
      for (var i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i))
      }

      str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-') // collapse dashes

      return str
    },
  },
  created () {
    // this.movies = this.$store.state.common.movies
    this.profession = window.localStorage.getItem('profession')
     if(this.$route.fullPath.includes('-s-')) {
      //let dorm = this.string_to_slug(this.branchedDormTitle)
      let path1 = this.$route.fullPath.split('-s-')
      let path = path1[0].replace('/', '')
      let route = { name: 'Branch', params: { dorm: path } }
      this.$router.push(route)
     }
  //  window.addEventListener('scroll', this.handleScroll)
    this.dormId = window.localStorage.getItem('dormid')
    this.url = window.localStorage.getItem('url')
//    this.getFormData()
  },
  destroyed () {
  //  window.removeEventListener('scroll', this.handleScroll)
  },
  mounted () {
    //this.setOffsets()
    this.getImages()
    this.getPersonCredits()
    this.getPersonDetails()
  //  this.getFormData()
    this.twitter_user = window.localStorage.getItem('first_name') + window.localStorage.getItem('last_name') // this.first_user + this.last_user
  },
  computed: {
  //...mapGetters(['movies']),
  },
  watch: {
    $route () {
      this.getPersonDetails()
    }
  }
}
</script>

<style lang="scss">
    @import "../assets/scss/components/dorm-detail";
    @import "../assets/scss/components/sticky-nav";
    .sticky-nav__space {
        height: 83px;
    }

    .mycolor2 {
        color: red;
    }

    .mytitleDetail {
        font-size: 15px;
        color: gray;
    }

    .mycomment {
        font-weight: 400;
        font-size: 16px;
    }

    .mysuccessMessage {
        font-size: 18px;
        text-align: center;
    }

    .mycenter {
        display: table;
        margin: 0 auto;
    }

    .mysize {
        font-size: 16px;
    }

  .mycolorBlue {
    color:#4b5ba4;
    font-weight: bold;
  }
    .mycolor2a {
    color:#17d9ae;
    font-weight: bold;
  }

.mysharebuttons {
    cursor: pointer;
    margin-top: 18px;
  }

  .mysharebuttons > .icon-font{
    font-size: 18px;
    color: #9198b2;
    width: 100%;
  }

  .mysharebuttons .icon-font > span{
    width: 33%;
    display: block;
    text-align: center;
    border-right: 1px solid #ddd;
      &:hover {
        .mybutton{
          color: #eb6081;
        }
      }
  }

  .mysharebuttons .icon-font > span:last-child{
    border-right: none;
  }

  .mycolorshare {
    color: #4b5ba4;
  }

  .myfontstyle {
  font-style: normal !important;
}

  .myborder {
          padding-top: 0px 0;
          padding-top: 0px 0;
      border-bottom: 1px solid rgba(172, 179, 201, 0.45);
      //border-top: 1px solid rgba(172, 179, 201, 0.45);
      margin-top:  0px;
      margin-bottom: 0px;

    border-left: none;
  }
</style>
